import Mesa from "./Mesa";
import "./styles.css";
import Swal from "sweetalert2";
import React, { useState, useEffect } from "react";

const ItemSalon = ({
  mesas,
  eliminarMesa,
  setMesas,
  esReserva,
  listaAsientos,
  maxAsientos,
  setListaAsientos,
  listaAsientosRegistrados,
}) => {
  const handleDragOver = (e) => {
    e.preventDefault();
  };
 
  const [selected, setSelected] = useState(false);
  const [maximoAsientos, setMaximoAsientos] = useState(false);

  const handleSeatClick = (seatId) => {
    if (listaAsientos.includes(seatId)) {
      setSelected(false);
      setMaximoAsientos(false);

      setListaAsientos((prevState) =>
        prevState.filter((seat) => seat !== seatId)
      );
    } else if (listaAsientos.length < maxAsientos) {
      setSelected(true);
      setMaximoAsientos(false);

      setListaAsientos((prevState) => [...prevState, seatId]);
    } else {
      setMaximoAsientos(true);
    }
  };
  const handleDrop = (e) => {
	console.log(esReserva)
    if (!esReserva) {
      e.preventDefault();
      const mesaId = e.dataTransfer.getData("mesaId");
      const mesa = mesas.find((mesa) => mesa.id === parseInt(mesaId));
      if (mesa) {
        const margenIzquierdo =
          parseInt(getComputedStyle(e.currentTarget).marginLeft) + 25;
        const margenSuperior =
          parseInt(getComputedStyle(e.currentTarget).marginTop) +23;
        const nuevaMesa = {
          ...mesa,
          x: (e.clientX - e.currentTarget.offsetLeft - margenIzquierdo),
          y: (e.clientY - e.currentTarget.offsetTop - margenSuperior),
        };
        const nuevasMesas = mesas.map((mesa) =>
          mesa.id === parseInt(mesaId) ? nuevaMesa : mesa
        );
        setMesas(nuevasMesas);
      }
    }
  };

  return (
    <div className="estiloSalon" onDragOver={handleDragOver} onDrop={handleDrop}>
      <div className="estiloEscenario">ESCENARIO</div>
      {mesas.map((mesa) => (
        <Mesa
          key={mesa.id}
          mesa={mesa}
		  onClick={handleSeatClick}
          eliminarMesa={eliminarMesa}
          esReserva={esReserva}
		  listaAsientosRegistrados={listaAsientosRegistrados}
		  listaAsientos={listaAsientos}
		  maxAsientos={maxAsientos}
        />
      ))}
    </div>
  );
};

export default ItemSalon;
